export enum JobType {
  FileInitialization = 1,
  FileSynchronization,
  FileCreation,
  ProjectCompletionCalculation,
  LanguageSynchronization,
  StatisticsCreation,
  LanguageAdding,
  LanguageDeleting,
  ProjectValidation,
  DeleteWorkspace,
}
